import { Grid } from '@mui/material';
import { FormApi } from 'final-form';
import { ChangeEvent, KeyboardEvent } from 'react';

import { IApiLocation } from '../../constants/api-interfaces';
import { EditUserFormValues } from '../../constants/interfaces';
import { formatPhoneNumber, normalizePhoneNumber, shouldPreventPhonePrefixDeletion } from '../../constants/utils';
import FormControlledSelect from './FormControlledSelect';
import FormControlledTextField from './FormControlledTextField';

type EditUserFormProps = {
  form: FormApi<EditUserFormValues>;
  locations: IApiLocation[];
  isEmailDisabled?: boolean;
  isLocationDisabled?: boolean;
  isStartDateDisabled?: boolean;
};

export default function EditUserForm({
  form,
  locations,
  isEmailDisabled = true,
  isLocationDisabled = false,
  isStartDateDisabled = false,
}: EditUserFormProps) {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="firstName"
          label="First Name"
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="lastName"
          label="Last Name"
          variant="outlined"
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <FormControlledTextField
          name="email"
          label="Email"
          variant="outlined"
          fullWidth
          disabled={isEmailDisabled}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="phoneNumber"
          label="Phone Number"
          variant="outlined"
          format={(value?: string) => formatPhoneNumber(value as string | undefined)}
          parse={(value?: string) => normalizePhoneNumber(value)}
          onChange={(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            form.change('phoneNumber', normalizePhoneNumber(event.target.value));
          }}
          onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => {
            if (shouldPreventPhonePrefixDeletion(event)) {
              event.preventDefault();
            }
          }}
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="dateOfBirth"
          label="Date of Birth"
          variant="outlined"
          type="date"
          slotProps={{ inputLabel: { shrink: true } }}
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlledTextField
          name="startDate"
          label="Start Date"
          variant="outlined"
          type="date"
          slotProps={{ inputLabel: { shrink: true } }}
          disabled={isStartDateDisabled}
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <FormControlledSelect
          name="locationId"
          label="Location"
          variant="outlined"
          data={locations.map((location) => ({
            label: location.name,
            value: location.id,
          }))}
          disabled={isLocationDisabled}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
